import { getDestinationIds, getLandmarkIds } from 'lib/search/filterIdUtils'

/**
 * Destination IDs eligible for the near-centre flash boost ranking experiment.
 * Pilot scope: single-place Sydney or Melbourne searches only (OSS-4403).
 */
export const NEAR_CENTRE_FLASH_BOOST_RANKING_DESTINATION_IDS: ReadonlySet<string> = new Set([
  'le_678c61ac5b4f91ca86e112fc50e63766', // Sydney
  'le_acf06cdd9c744f969958e1f085554c8b', // Sydney (alternate place ID)
  'le_15fa44474c92da27cf2125373356db4c', // Melbourne
])

export function isNearCentreFlashBoostRankingEligible(filters: {
  destinationId?: string
  destinationIds?: Array<string>
  landmarkId?: string
  landmarkIds?: Array<string>
  propertyId?: string
  bounds?: string
  sortBy?: App.OfferListSortByOptions
}): boolean {
  if (filters.propertyId) return false
  if (filters.bounds) return false

  const landmarkIds = getLandmarkIds(filters)
  if (landmarkIds && landmarkIds.length > 0) return false

  const destinationIds = getDestinationIds(filters)
  if (!destinationIds || destinationIds.length !== 1) return false
  if (!NEAR_CENTRE_FLASH_BOOST_RANKING_DESTINATION_IDS.has(destinationIds[0])) return false

  return !filters.sortBy || filters.sortBy === 'recommended'
}
